import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';
import { GetPerDiemRequestFragment } from './getAllPerDiemsApi';

export const GetPerDiemsMissingTimeEntriesQuery = gql`
  query GetPerDiemsMissingTimeEntries {
    per_diems_missing_time_entries {
      edges {
        node {
          ...PerDiemRequestDetails
        }
      }
    }
  }
  ${GetPerDiemRequestFragment} 
`;

const marshallData = ({ data, ownProps }) => {
  const allPerDiemsMissingTimeEntries = querySelector(data, '$.per_diems_missing_time_entries.edges[*].node', []);
  return {
    ...ownProps,
    data,
    allPerDiemsMissingTimeEntries,
  };
};

const queryGetAllPerDiemsData = graphql(GetPerDiemsMissingTimeEntriesQuery, {
  props: marshallData,
});

export const queryGetPerDiemsMissingTimeEntriesGQL = compose(
  queryGetAllPerDiemsData,
  queryMetaHandler,
  omitProps(['data']),
);
